var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSal1Badge(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 27,
    height: 33,
    viewBox: "0 0 27 33",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2.13351 24.222C1.92721 24.1046 1.7998 23.8855 1.7998 23.6482V5.61283C1.7998 5.34889 1.96038 5.10853 2.20356 5.00592C11.0877 1.25739 16.2435 1.35492 25.1259 5.40339C25.3624 5.51118 25.5157 5.75044 25.5128 6.0103L25.3178 23.6531C25.3152 23.8878 25.1881 24.1035 24.9841 24.2196L13.8832 30.5365C13.6808 30.6517 13.4326 30.6517 13.2301 30.5365L2.13351 24.222Z",
    stroke: "#719CF9",
    strokeWidth: 1.4
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M25.2172 14H1.7832V21H25.2172V14Z",
    fill: "#719CF9"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSal1Badge);
export default __webpack_public_path__ + "static/media/SAL1_Badge.385cdd69d4608d0f15042ff30fc13ef7.svg";
export { ForwardRef as ReactComponent };